import { createSlice } from "@reduxjs/toolkit";
import saveMicroscopyMeasurements from '../../../rtk-apis/microscopy/saveMeasurements'

const initialState = {
  status: "",
  result: [],
  message: "",
  loading: false,
  error: ""
};

const saveMicroscopyMeasurementsSlice = createSlice({
  name: "patientMicroscopicData",
  initialState,
  reducers: {
    resetStatus(state: any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveMicroscopyMeasurements.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(saveMicroscopyMeasurements.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(saveMicroscopyMeasurements.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default saveMicroscopyMeasurementsSlice.reducer;
export const { resetStatus } = saveMicroscopyMeasurementsSlice.actions;
